export interface FieldObject {
    key: string;
    value: any;
    class?: string | FieldClass;
    type?: string;
    subfield?: string;
    icon?: string;
    link?: string;
    tooltip?: string
}
export interface FieldClass {
    [key: string]: boolean;
}


// TODO: faire un humanReadableSubfield et le mettre dans le composant field. (comme date)
export const mapSubfields: any = {
    sd_status: [
        undefined,
        'SD card absent',
        'SD card inserted',
        'SD card formatted',
        'SD card OK',
        'SD card defect',
        'SD card incompatible',
        'SD card too small',
    ],
    alim_status: [
        undefined,
        'Alimentation failure',
        'Alimentation OK',
    ],
    in_use: {
        'station': 'Weather Station',
        '30min': 'Default (30min)',
        'gefs': 'Weather Forecast',
    },
    subtype: {
        TPG: 'Therm',
        NVG: 'Starter pack',
    },
    plug_connected_boiler: {
        true: 'Boiler adaptor',
        false: 'Power plug',
        undefined: 'No boiler configuration.',
    },
    hw_version: {
        246 : 'Welcome v1',
        239 : 'Outdoor Camera',
        217 : 'Outdoor Camera with Siren',
        253 : 'Therm v1',
        248 : 'Therm v2',
        245 : 'Therm v3',
        229 : 'Therm v4',
        250 : 'Station v1',
        251 : 'Station v2',
        241 : 'Station v3',
        227 : 'Station v4',
        202 : 'Station v5',
        1 : 'Outdoor/Other air unit',
        2 : 'Outdoor unit v1',
        3 : 'Rain gauge v1',
        6 : 'Anemometer v1',
        11 : 'Outdoor unit v2',
        48 : 'Outdoor unit v3',
        49 : 'Other air unit v2',
        50 : 'Rain gauge v2',
        240 : 'Homecoach V1',
        211 : 'Homecoach V2',
        247 : 'Vaillant Therm v1',
        237 : 'Vaillant Therm v2',
        232 : 'MFH V1',
        235 : 'Smoke Detector v1',
        236 : 'Velux Gateway v1',
        219 : 'Velux Gateway v2',
        238 : 'Magellan Gateway v1',
        218 : 'Magellan Gateway v2',
        208 : 'Magellan Gateway v3',
        195 : 'Magellan Gateway v4',
        21 : 'NLC V1',
        22 : 'NLD V1',
        14 : 'NLF V1',
        15 : 'NLL V1',
        16 : 'NLM V1',
        17 : 'NLP V1',
        18 : 'NLT V1',
        19 : 'NLV V1',
        24 : 'NLTS V1',
        25 : 'NLFN V1',
        29 : 'NLUI V1',
        30 : 'NLUF V1',
        31 : 'NLUP V1',
        32 : 'NLUO V1',
        28 : 'NLFE V1',
        46 : 'NLIV V1',
        36 : 'NLIS V1',
        42 : 'NLW V1',
        47 : 'NLH V1',
        51 : 'NLJ V1',
        52 : 'NLY V1',
        56 : 'NLFO V1',
        57 : 'NLOC V1',
        55 : 'NLIB V1',
        234 : 'Muller Gateway v1',
        230 : 'Muller Gateway v2',
        201 : 'Muller Gateway v3',
        58 : 'Muller Module v1',
        59 : 'Muller Module v3',
        233 : 'Bubendorff Gateway v1',
        224 : 'Bubendorff Gateway v2',
        231 : 'Doorbell v1',
        23 : 'Doorlock v1',
        194 : 'Smarther wN 2024',
        226 : 'Smarther v2',
        222 : 'OpenTherm v1',
        223 : 'Clim v0',
        225 : 'Ecometer',
        220 : 'CO Detector v1',
        216 : 'ELG v1A (deprecated)',
        215 : 'ELG v1',
        214 : 'ELG v2',
        213 : 'BNCX',
        212 : 'Smarther AC v1',
        191 : 'Smarther AC v2',
        44 : 'IR Emitter',
        45 : 'HVAC actuator',
        209 : 'MyHomeServer1',
        210 : 'Indoor Camera Pro v1',
        205 : 'Full IP DES v1',
        206 : 'Phoenix Audio v1',
        207 : 'Phoenix Video v1',
        203 : 'Classe 100X',
        200 : 'Classe 100X Retoco',
        199 : 'Easy Kit Connected',
        204 : 'EVSE v1',
        198 : 'F460',
        197 : 'Indoor Camera Lifestyle v1',
    },

};
